/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { AdAlertListCardVehicleFragmentDoc } from '../../../../../ad-alert-cards/src/lib/AdAlertListCard/AdAlertListCard.hook'
import { BookabilityCardVehicleFragmentDoc } from '../../../../../ad-telematics-cards/src/lib/BookabilityCard/BookabilityCard.hook'
import { SystemComponentsCardVehicleFragmentDoc } from '../../../../../ad-telematics-cards/src/lib/SystemComponentsCard/SystemComponentsCard.hook'
import { AdVehicleStreamAlertVehicleMapVehicleFragmentDoc } from '../../../../../ad-vehicle-stream/src/lib/AlertVehicleMap/AlertVehicleMap.hook'
import { VehicleDrawerAlertFragmentDoc } from '../../../../../alert-drawer/src/lib/VehicleDrawerAlerts.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { VehicleMissionCardVehicleFragmentDoc } from '../../../../../vehicle-mission/src/lib/VehicleMissionCard/vehicleMissionCard.hook'

const defaultOptions = {} as const
export type AdVehicleDrawerContentQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  taskNotificationTypes:
    | Array<Types.TaskNotificationType>
    | Types.TaskNotificationType
  taskNotificationStatus:
    | Array<Types.TaskNotificationStatus>
    | Types.TaskNotificationStatus
  withAdAlerts: Types.Scalars['Boolean']['input']
}>

export type AdVehicleDrawerContentQuery = {
  __typename?: 'Query'
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    isSelfDriving: boolean
    inService: boolean | null
    notInServiceReasons: Array<Types.NotInServiceReason> | null
    totalChildrenInVehicle: number | null
    totalPassengersInVehicle: number | null
    totalPassengersToPickUp: number | null
    totalWheelchairUsersInVehicle: number | null
    taskNotifications: {
      __typename?: 'TaskNotificationList'
      tasks: Array<
        | {
            __typename?: 'HubServiceNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'IvcTaskNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'PassengerUnbuckled'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'RoadBlockageTaskNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'ShiftDeviationNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopAccessibilityDownvotedByDrivers'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopActivationFailedNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopAreaMissingActiveStopsNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopDownVotedByDrivers'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopPotentiallyUnreachable'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'StopValidationFailed'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'TimeManagementNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename: 'TripPrebookingNoAssignment'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
            status: Types.TaskNotificationStatus
            rejectionAt: string
            assigned: {
              __typename?: 'TaskStateChangeDetails'
              backofficeUserId: string | null
              backofficeUser: {
                __typename?: 'BackofficeUser'
                id: string
                username: string
              } | null
            } | null
            trip: {
              __typename?: 'Trip'
              id: string
              customer: {
                __typename?: 'Customer'
                id: string
                firstName: string | null
                lastName: string | null
                phoneNumber: string | null
              } | null
              pickup: {
                __typename?: 'TripTransferInformation'
                promisedTime: {
                  __typename?: 'DateTimeInterval'
                  from: string
                  to: string
                }
              }
              seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
            } | null
            resolved: {
              __typename?: 'TaskStateChangeDetails'
              initiatedBySystem: boolean
            } | null
            pickupStop: {
              __typename?: 'Stop'
              id: string
              names: Partial<Record<'de' | 'en' | 'no', string>>
              address: {
                __typename?: 'StopAddress'
                street: string | null
                houseNumber: string | null
                postalCode: string | null
                city: string | null
              }
              routingLocation: {
                __typename?: 'Location'
                latitude: number
                longitude: number
              }
            } | null
            dropoffStop: {
              __typename?: 'Stop'
              id: string
              names: Partial<Record<'de' | 'en' | 'no', string>>
              address: {
                __typename?: 'StopAddress'
                street: string | null
                houseNumber: string | null
                postalCode: string | null
                city: string | null
              }
              routingLocation: {
                __typename?: 'Location'
                latitude: number
                longitude: number
              }
            } | null
            stateChanges: Array<{
              __typename: 'TaskStateChangeDetails'
              initiatedBySystem: boolean
              timestamp: string | null
              to: Types.TaskNotificationStatus
              backofficeUser: {
                __typename?: 'BackofficeUser'
                username: string
              } | null
            }>
          }
        | {
            __typename?: 'VehicleAvailabilityNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename?: 'VehicleIncidentNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
        | {
            __typename: 'VehicleSurveillanceNotification'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
            status: Types.TaskNotificationStatus
            employee: {
              __typename?: 'Employee'
              id: string
              firstName: string | null
              lastName: string | null
            } | null
            vehicle: {
              __typename?: 'Vehicle'
              id: string
              highVoltageBatteryLevel: number | null
              cruisingRange: number | null
              totalPassengersInVehicle: number | null
              inService: boolean | null
              label: number | null
              licensePlate: string | null
              isSelfDriving: boolean
              hardwareConfiguration: {
                __typename?: 'HardwareConfiguration'
                tablet: {
                  __typename?: 'Tablet'
                  phoneNumber: string | null
                } | null
              } | null
              fleet: { __typename?: 'Fleet'; id: string } | null
              lastVehicleInteraction: {
                __typename?: 'VehicleInteraction'
                type: Types.VehicleInteractionType
              } | null
            } | null
            assigned: {
              __typename?: 'TaskStateChangeDetails'
              backofficeUserId: string | null
              backofficeUser: {
                __typename?: 'BackofficeUser'
                id: string
                username: string
              } | null
            } | null
            stateChanges: Array<{
              __typename: 'TaskStateChangeDetails'
              initiatedBySystem: boolean
              timestamp: string | null
              to: Types.TaskNotificationStatus
              backofficeUser: {
                __typename?: 'BackofficeUser'
                username: string
              } | null
            }>
          }
        | {
            __typename?: 'VehicleWaypointAttendance'
            createdAt: string
            id: string
            notificationType: Types.TaskNotificationType
          }
      >
    } | null
    pooling: {
      __typename?: 'Pooling'
      reason: Types.PoolingReason | null
      enabled: boolean
      enabledUpdatedAt: string | null
    } | null
    currentlyLocatedInServiceBreakLocation: {
      __typename?: 'ServiceBreakLocation'
      id: string
    } | null
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      id: string
      adState: Types.FccWaypointState | null
      adStateUpdatedAt: string | null
      routeProvider: Types.FccRouteProvider | null
      cabinSafetyCheckStatus: Types.FccCabinSafetyCheckStatus | null
      fccStop: {
        __typename?: 'FccStop'
        id: string | null
        names: Partial<Record<'de' | 'en' | 'no', string>>
      } | null
      stopWithServiceArea: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            estimatedAt: string
            id: string
            pickedUpAt: string | null
            deliveryStatus: Types.FccWaypointDeliveryActionStatus
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
            trip: { __typename?: 'Trip'; id: string } | null
          }
        | {
            __typename: 'FccWaypointHubReturnAction'
            estimatedAt: string
            isPlannedHubReturn: boolean
            reason: Types.FccWaypointHubReturnReason
            id: string
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            area: {
              __typename?: 'Area'
              id: string
              name: string | null
              type: Types.AreaType
              details:
                | { __typename?: 'CooperationDetails' }
                | { __typename?: 'HubDetails'; displayName: string }
                | { __typename?: 'InFieldBreakDetails' }
                | { __typename?: 'ShortBreakDetails' }
                | null
              serviceArea: { __typename?: 'ServiceArea'; id: string }
            } | null
          }
        | {
            __typename: 'FccWaypointPickupAction'
            estimatedAt: string
            id: string
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            pickedUpAt: string | null
            pickupStatus: Types.FccWaypointPickupActionStatus
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
            trip: { __typename?: 'Trip'; id: string } | null
          }
        | {
            __typename: 'FccWaypointReallocationAction'
            estimatedAt: string
            id: string
            promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          }
      >
      stop: {
        __typename?: 'Stop'
        routingLocation: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        }
      } | null
    }> | null
    latestLocation: {
      __typename?: 'VehicleLocation'
      heading: number | null
      timestamp: string | null
      location: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      } | null
    } | null
    latestADTelemetry: {
      __typename?: 'ADTelemetry'
      missionConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      signalConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      cabinConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
    } | null
    fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
    fccHandledByOperatorDetails: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    fccCurrentAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{
        __typename: 'FccAdAlert'
        id: string
        type: Types.FccAdAlertType
        status: Types.FccAdAlertStatus
        createdAt: string
      }>
    } | null
  }
}

export const AdVehicleDrawerContentDocument = gql`
    query AdVehicleDrawerContent($vehicleId: ID!, $taskNotificationTypes: [TaskNotificationType!]!, $taskNotificationStatus: [TaskNotificationStatus!]!, $withAdAlerts: Boolean!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    ...VehicleMissionCardVehicle
    ...AdVehicleStreamAlertVehicleMapVehicle
    ...BookabilityCardVehicle
    ...SystemComponentsCardVehicle
    ...AdAlertListCardVehicle @include(if: $withAdAlerts)
    taskNotifications(
      status: $taskNotificationStatus
      types: $taskNotificationTypes
    ) {
      tasks {
        ...VehicleDrawerAlert
      }
    }
  }
}
    ${VehicleMissionCardVehicleFragmentDoc}
${AdVehicleStreamAlertVehicleMapVehicleFragmentDoc}
${BookabilityCardVehicleFragmentDoc}
${SystemComponentsCardVehicleFragmentDoc}
${AdAlertListCardVehicleFragmentDoc}
${VehicleDrawerAlertFragmentDoc}`

/**
 * __useAdVehicleDrawerContentQuery__
 *
 * To run a query within a React component, call `useAdVehicleDrawerContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleDrawerContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleDrawerContentQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      taskNotificationTypes: // value for 'taskNotificationTypes'
 *      taskNotificationStatus: // value for 'taskNotificationStatus'
 *      withAdAlerts: // value for 'withAdAlerts'
 *   },
 * });
 */
export function useAdVehicleDrawerContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  > &
    (
      | { variables: AdVehicleDrawerContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  >(AdVehicleDrawerContentDocument, options)
}
export function useAdVehicleDrawerContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  >(AdVehicleDrawerContentDocument, options)
}
// @ts-ignore
export function useAdVehicleDrawerContentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleDrawerContentQuery,
  AdVehicleDrawerContentQueryVariables
>
export function useAdVehicleDrawerContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleDrawerContentQuery,
        AdVehicleDrawerContentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleDrawerContentQuery | undefined,
  AdVehicleDrawerContentQueryVariables
>
export function useAdVehicleDrawerContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleDrawerContentQuery,
        AdVehicleDrawerContentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleDrawerContentQuery,
    AdVehicleDrawerContentQueryVariables
  >(AdVehicleDrawerContentDocument, options)
}
export type AdVehicleDrawerContentQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerContentQuery
>
export type AdVehicleDrawerContentLazyQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerContentLazyQuery
>
export type AdVehicleDrawerContentSuspenseQueryHookResult = ReturnType<
  typeof useAdVehicleDrawerContentSuspenseQuery
>
export type AdVehicleDrawerContentQueryResult = Apollo.QueryResult<
  AdVehicleDrawerContentQuery,
  AdVehicleDrawerContentQueryVariables
>
